<template>
	<div class="affiliate-promo-material">
		<div class="titlebar">
			<div class="title">
				<h2 class="h5 h-alter" v-text="$__('profile.text.banners.title')"></h2>

<!--				<a href="/profile/affiliate/download-banners" title="Download all banners" class="link link-arrow">Download all banners <svg class="ticon"><use xlink:href="/images/icons.svg#icon-chevron-right"></use></svg></a>-->
			</div>
			<div class="links">
				<a href="#" :title="$__('profile.text.request.change')" v-text="$__('profile.text.request.change')"></a>
				<a href="#" :title="$__('profile.text.help')" v-text="$__('profile.text.help')"></a>
			</div>
		</div>

		<div class="material-wrapper">
			<div class="row">
				<div class="col-md-8 empty"></div>
				<div class="col-md-4">
					<div class="info-main">
						<div v-text="$__('profile.affiliate.expiration_date')"></div>
						<div v-text="$__('profile.affiliate.coupon_earnings')"></div>
					</div>
				</div>
			</div>
			<div class="single" v-for="(banner, index) in banners" :key="banner.id">
				<div class="row align-items-md-center">
					<div class="col-md-8 content">
						<div class="image">
							<img class="img-fluid" loading="lazy" :src="`/storage/${banner.picture}`" :alt="banner.description" :title="banner.description">
							<a :href="`/storage/${banner.picture}`" :title="$__('profile.text.banner.download')" class="btn btn-primary btn-sm" v-text="$__('profile.text.banner.download')" download target="_blank"></a>
						</div>

						<div class="code">
							<input readonly="readonly" type="text" :value='embedCode(banner)'>
							<button class="btn btn-plain btn-copy"><svg class="ticon"><use xlink:href="/images/icons.svg#icon-link"></use></svg></button>
						</div>

						<div class="info">
							<p v-text="banner.description"></p>
						</div>
					</div>

					<div class="col-md-4 payout">
						<div class="info">
							<div class="date">{{ banner.valid_until | formatDate }}</div>
							<div class="amount">{{ banner.earnings > 0 ? (banner.earnings | formatCurrency(banner.locale)) : 0 }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
export default {
	name: "Banners",
	props: {
		banners: Array
	},
	methods: {
		embedCode(banner) {
			const host = window.location.protocol + '//'  + window.location.hostname;
			return `<a href="${host}?affiliate=${banner.uuid}" target="_blank" title="Lupit pole, We support every style with style!" rel="noopener"><img src="${host}/storage/${banner.picture}" alt="${banner.title}"></a>`;
		}
	},
	mounted() {
		console.log(this.banners)
	}
}
</script>
